import React, {useContext, useEffect, useState} from 'react';
import Header from "../bundles/common/components/Header";
import Footer from "../bundles/common/components/Footer";
import { useMediaQuery, useTheme } from '@mui/material';
import Sidebar from "../bundles/common/components/Sidebar";

// Authorized abstracts away the header/footer/sidebar decision making
const Authorized =({children}) => {
    const theme = useTheme();
    const isSmallOrLarger = useMediaQuery(theme.breakpoints.up('sm'));

    return(
        <>
            <Header/>
            {children}
            {isSmallOrLarger?
                <Sidebar/>
                :
                <Footer/>
            }
        </>
    )
};

export default Authorized;
